var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute inset-0"},[_c('scroll-grid-2',{attrs:{"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }